import { Placeholder } from 'modules/common/components/Placeholder';
import { isSSG } from 'modules/common/utils/isSSG';
import { useCurrentTopBanner } from 'modules/strapi/hooks/useCurrentTopBanner';

import { TopBanner } from './TopBanner';

export const TopBannerContainer = () => {
  const { loaded, topBanner } = useCurrentTopBanner();

  return (
    <Placeholder
      hasPlaceholder={!loaded || !topBanner || isSSG()}
      placeholder={null}
    >
      <TopBanner>{topBanner?.text}</TopBanner>
    </Placeholder>
  );
};
